export enum OutboundFaxImportKind {
  standard = 'standard',
  legacySweep = 'legacy_sweep',
}
